import { connect } from 'react-redux';
import * as upsertAccountModalActions from '../../UpsertAccountModal/UpsertAccountModalActions';
import { VIEWS } from '../../UpsertAccountModal/UpsertAccountModalConstants';
import withContextualSidebar from '../ContextualSidebarContainer';
import * as actions from './NetWorthSidebarActions';
import * as selector from './NetWorthSidebarSelector';
import NetWorthSidebarView from './NetWorthSidebarView';
import {
  currentClientSelector,
  hasAccessToLinkAccountsSelector,
  hasNetWorthAccessSelector,
  hasPlaidSelector,
  isFinancialPlanEnabledSelector,
  selectAkoyaPhase,
  hasAccessToEditProfileSelector,
} from '../../CommonSelectors/CommonAreaSelector';
import { currentRouteSelector } from '../../CommonComponents/Router/Selector';
import { externalHostSelector } from '../../ConsumerArea/ConsumerAreaSelector';

const mapStateToProps = state => ({
  currentClient: currentClientSelector(state),
  errors: selector.errorsSelector(state),
  isFetching: selector.isFetchingSelector(state),
  accountGroups: selector.accountGroupsSelector(state),
  totalNetWorth: selector.totalNetWorthSelector(state),
  isNetworthActive: selector.isNetworthActiveSelector(state),
  currentRoute: currentRouteSelector(state),
  dataVersion: selector.dataVersionSelector(state),
  hasOrionManagedAccount: selector.hasOrionManagedAccountSelector(state),
  managedAccountGroups: selector.selectManagedAccountGroups(state),
  hasPlaid: hasPlaidSelector(state),
  hasAccessToLinkAccounts: hasAccessToLinkAccountsSelector(state),
  externalHost: externalHostSelector(state),
  isFinancialPlanEnabled: isFinancialPlanEnabledSelector(state),
  hasNetWorthAccess: hasNetWorthAccessSelector(state),
  showAddManualAccount: selector.allowAddManualAccountsSelector(state),
  unmanagedAccountsLabel: selector.selectUnmanagedAccountsLabel(state),
  akoyaPhase: selectAkoyaPhase(state),
  hasAccessToEditProfile: hasAccessToEditProfileSelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchOrionAccountsData: clientId => dispatch(actions.fetchOrionAccountsData(clientId)),
  onLinkClick: (controller, params) => window.ADV.util.Router.go2(controller, params),
  fetchNetWorthData: (clientId, isInitialFetch) =>
    dispatch(actions.fetchNetWorthData(clientId, isInitialFetch)),
  showLinkAccountModal: hasAccessToLinkAccounts =>
    dispatch(
      upsertAccountModalActions.setCurrentView(hasAccessToLinkAccounts ? VIEWS.LINK : VIEWS.ADD),
    ),
  setErrors: errors => dispatch(actions.setErrors(errors)),
  onAccountClick: (currentClient, account) => {
    const accountId = account.isApexPendingAction
      ? account.ManagedAccountId
      : account.Item.AccountId;

    if (account.isApexPendingAction) {
      ADV.util.Router.go2('ApexAccount', {
        clientId: currentClient.Id,
        accountId,
      });
    } else if (currentClient.IsOrionClient && account.Item.IsOrionReportableAccount) {
      ADV.util.Router.go2('AccountPerformanceReporting', {
        clientId: currentClient.Id,
        accountId,
        tabSlug: account.landingPerformanceReportingTab || 'summary',
        isApex: account.isApex || false,
      });
    } else if (account.IsLinked) {
      ADV.util.Router.go2('Transactions', {
        clientId: currentClient.Id,
        accountId,
      });
    } else if (account.IsEditable) {
      dispatch(
        upsertAccountModalActions.setFocusedAccount(account.Item, {
          isNew: false,
          isEditable: !account.Item.IsOrion,
        }),
      );
      dispatch(upsertAccountModalActions.setCurrentView(VIEWS.EDIT));
    }
  },
  openAddAccountModal: viewType => {
    dispatch(upsertAccountModalActions.setCurrentView(viewType));
  },
});

const NetWorthSidebarContainer = connect(mapStateToProps, mapDispatchToProps)(NetWorthSidebarView);

export default withContextualSidebar(NetWorthSidebarContainer, { title: 'Net Worth' });
